import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import {
  incentiveProgram,
  morphingLegislationRules
} from '../../project/project.constants';
import { formTypes } from '../../form/form.constants';
import { ProjectForm } from '../../project/models/form.model';
import { UserContextService } from '../../user/services/user-context.service';
import { FormShareService } from '../../form/services/share.service';

@Component({
  selector: 'fl-step-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss']
})
export class StepApplicationComponent implements OnInit {
  form: ProjectForm;
  incentiveProgram: string;

  @ViewChild('step', { static: true }) stepApplicationBlock: TemplateRef<any>;

  thenBlock: TemplateRef<any>;

  constructor(
    private shareService: FormShareService,
    private userContext: UserContextService
  ) {}

  ngOnInit() {
    this.form = this.getForm();
    this.thenBlock = this.stepApplicationBlock;
  }
  // This function gets the approriate form based on incentive program.
  getForm() {
    const that = this;
    that.incentiveProgram = this.shareService.currentIncentiveProgram;
    return that.shareService.stepForm;
  }
}
